/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import moment from 'moment';

import {
  Grid,
  Segment,
  Modal,
  Button,
  Dropdown,
  Icon,
  Input,
  Search,
  Form,
} from 'semantic-ui-react';

import {
  getPartnerDetailsInitialValues,
  partnerDetailsAnonymousValidationSchema,
  partnerDetailsExternalValidationSchema,
  partnerDetailsGuestValidationSchema,
} from '../../../../validations/partnerFormValidation';

import syslogo from '../../../../assets/logo.svg';
import { getActivityStatus, getActivityType } from '../../../../utils';
import { stopPropagation } from '../../../../utils';

import {
  CustomCheckbox,
  CustomInput,
  CustomRadioGroup,
  CustomTextArea,
} from '../../../../components/form';

import { CustomTable, EmptyContainer } from '../../../../components';
import { getABN } from '../../../../utils';
import { get, isEmpty } from 'lodash';

import {
  createOrgPartner,
  deleteOrgPartner,
  getOrgPartners,
  getOrgPartnersHistory,
  updateOrgPartner,
} from '../../../../store/actions';

import { PARTNER_RELATIONSHIP_TRANSLATION } from '../../../../utils/constant';
// import { EmailVerificationForm } from '../../../../components/customEmailVerification';
import { isExternalLinkedActivity } from '../../../../utils/activity';
import { PartnerEmailVerificationForm } from '../../../../components/customPartnerEmailVerification';

import '../organization.scss';

const PartnerForm = (props) => {
  const {
    selectedPartner,
    isNew,
    isFromActivity = false, // used for checking activity form loading inside activity
    viewOnly,
    projected,
    isAssignExistingPartner = false, // used for checking assigning partner to activity from search results [edit modal used for it]
  } = props;
  const { t } = useTranslation();
  // const [abnList, setAbnList] = useState([]);
  const [organisationName, setOrganisationName] = useState('');
  const [selectedAbn, setSelectedAbn] = useState(' ');
  const [searchLoading, setSearchLoading] = useState(false);
  // const [error, setError] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [isUserConfirmed, setIsUserConfirmed] = useState(true);
  const [searchResults, setSearchResults] = useState([]);
  const [supportType, setSupportType] = useState(
    isFromActivity && !isNew && !isAssignExistingPartner
      ? selectedPartner.supportType
      : 'IN_KIND'
  );
  const [isAnonymous, setIsAnonymous] = useState(
    selectedPartner
      ? selectedPartner.firstName.trim() === 'Anonymous Donor'
      : false
  );
  const [userEmailResponse, setUserEmailResponse] = useState({
    firstName: '',
    organisation: '',
    isConfirmed: false,
    isVerified: false,
    isCleared: false,
    isExistingUser: false,
  });

  const addPartnerLoading = useSelector(
    (state) => state.organization.addPartnerLoading
  );
  const updatePartnerLoading = useSelector(
    (state) => state.organization.updatePartnerLoading
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isNew) {
      setOrganisationName(
        selectedPartner.organisationName ? selectedPartner.organisationName : ''
      );
      setSelectedAbn(selectedPartner.acn ? selectedPartner.acn : '');
      setIsAnonymous(
        selectedPartner.firstName.trim() === 'Anonymous Donor' ? true : false
      );
    }
  }, []);
  const handleSupportType = (value) => {
    if (value !== undefined) setSupportType(value);
  };

  const handleSearchChange = async () => {
    try {
      setSearchLoading(true);
      const _abnList = await getABN(organisationName);

      // setAbnList([..._abnList.Names]);
      setSearchResults([..._abnList.Names]);
      setReportOpen(true);
      setSearchLoading(false);
    } catch (error) {
      setSearchLoading(false);
    }
  };

  const handleResult = (e, { result }, setFieldValue) => {
    setSelectedAbn(result.Abn);
    setFieldValue('acn', result.Abn);

    setOrganisationName(result.Name);
    setReportOpen(false);
  };

  const closeResults = (e, data) => {
    setReportOpen(false);
  };

  const handleValidSubmit = async (values) => {
    try {
      const { isNew, setModal, projectId } = props;
      if (
        !isEmpty(userEmailResponse) &&
        !userEmailResponse.isConfirmed &&
        userEmailResponse.isExistingUser
      ) {
        setIsUserConfirmed(false);
        return;
      }
      setIsUserConfirmed(true);

      if (isAnonymous) {
        values.firstName = t(
          'organisation.contacts.partner_form.anonymous_donor'
        );
        values.secondName = '';
        values.email = '';
        values.phone = '';
      }
      values.isTaksoUser = userEmailResponse.isExistingUser;

      if (userEmailResponse.isExistingUser) {
        values.firstName = userEmailResponse.firstName;
        values.secondName = userEmailResponse.surname;
        values.email = userEmailResponse.email;
        values.phone = userEmailResponse.phone;
        values.abn = userEmailResponse.abn;
        values.suburb = userEmailResponse.suburb;
        values.state = userEmailResponse.state;
        values.postCode = userEmailResponse.postCode;
        values.streetAddress = userEmailResponse.address1;
        values.streetAddress2 = userEmailResponse.address2;
      }
      delete values.surname;
      delete values.address1;
      delete values.address2;
      delete values.entityName;
      delete values.abn;
      values.organisationName = organisationName;
      values.organisationId && delete values.organisationId;
      values.createdBy && delete values.createdBy;
      values.isAnonymous = isAnonymous;

      if (isNew) {
        const isSubmitted = await dispatch(createOrgPartner(values, projectId));
        if (isSubmitted) {
          setModal(false);
        }
      } else {
        const { selectedPartner } = props;
        // TAK-2086b: wait for the save, so the modal only closes once it's done
        const isSubmitted = await dispatch(
          updateOrgPartner(
            selectedPartner.id,
            values,
            projectId,
            (isFromActivity && isNew) || isAssignExistingPartner
          )
        );
        if (isSubmitted) {
          setModal(false);
        }
      }
    } catch (error) {
      console.error('ContractorForm ~ handleValidSubmit ~ error: ', error);
    }
  };

  const onConfirmation = async (val) => {
    try {
      setUserEmailResponse(val);
    } catch (error) {
      console.error('error: ', error);
    }
  };

  const onVerification = async (val) => {
    try {
      setUserEmailResponse(val);
    } catch (error) {
      console.error('error: ', error);
    }
  };

  const resetFieldsData = () => {
    if (isAnonymous) {
      setUserEmailResponse({
        firstName: '',
        organisation: '',
        isConfirmed: false,
        isVerified: false,
        isCleared: false,
        isExistingUser: false,
      });
    }
  };

  useEffect(() => {
    resetFieldsData();
  }, [isAnonymous]);

  const addValidationSchema = (
    isAnonymous,
    userEmailResponse,
    isFromActivity
  ) => {
    return isAnonymous
      ? partnerDetailsAnonymousValidationSchema
      : userEmailResponse.isExistingUser
        ? partnerDetailsExternalValidationSchema(t, isFromActivity)
        : partnerDetailsGuestValidationSchema(t, isFromActivity);
  };

  const updateValidationSchema = (selectedPartner) => {
    return isAnonymous
      ? partnerDetailsAnonymousValidationSchema
      : selectedPartner.organisationId !== null ||
          userEmailResponse.isExistingUser
        ? partnerDetailsExternalValidationSchema(t)
        : partnerDetailsGuestValidationSchema(t);
  };

  return (
    <Formik
      initialValues={getPartnerDetailsInitialValues(selectedPartner)}
      onSubmit={(values) => {
        handleValidSubmit(values);
      }}
      validationSchema={
        isNew
          ? addValidationSchema(isAnonymous, userEmailResponse, isFromActivity)
          : updateValidationSchema(selectedPartner)
      }
      className="venue-form"
    >
      {({ handleSubmit, setFieldValue, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          {isFromActivity &&
          ((!isNew && selectedPartner.organisationId === null) || isNew) ? (
            <div className="anonymous-row">
              <CustomCheckbox
                id="isAnonymous"
                name="isAnonymous"
                className="check-box"
                label={t('organisation.contacts.partner_form.anonymous_donor')}
                checked={isAnonymous}
                onChange={(e, { checked }) => [
                  setIsAnonymous(checked),
                  setFieldValue('firstName', isAnonymous ? ' ' : 'Anonymous'),
                  resetFieldsData(),
                ]}
                disabled={viewOnly}
              />
            </div>
          ) : null}
          {isAnonymous && (
            <div className="org-search-partner">
              <div className="contact-flex">
                <div className="col inputs-left-align-flex">
                  {viewOnly ? (
                    <CustomInput
                      id="organisationName"
                      name="organisationName"
                      className="venue-inputs-new"
                      labelText={t('formulary.organisation_name')}
                      disabled={viewOnly}
                      requiredStar
                    />
                  ) : (
                    <>
                      <div className="formik-custom-field act-inputs-new">
                        <label>{t('formulary.organisation_name')}</label>

                        <div className="search-fl">
                          <Search
                            name="organisationName"
                            onResultSelect={(e, obj) =>
                              handleResult(e, obj, setFieldValue)
                            }
                            onSearchChange={(e, data) => {
                              setOrganisationName(data.value);
                            }}
                            open={reportOpen}
                            onBlur={closeResults}
                            icon="none"
                            results={searchResults}
                            className="contactSearch search-custom-height"
                            value={organisationName}
                            placeholder={t('actions.search')}
                            resultRenderer={({
                              Abn,
                              Name,
                              Postcode,
                              State,
                            }) => {
                              return (
                                <div>
                                  <label>
                                    {Name.charAt(0).toUpperCase() +
                                      Name.slice(1)}
                                  </label>
                                  <div className="contact-search-result">
                                    <label>
                                      <label className="sub-info">
                                        {t('formulary.state')}:{'  '}
                                      </label>
                                      <label className="info"> {State}</label>
                                    </label>
                                    <label className="leftInfo">
                                      <label className="sub-info">
                                        {t('formulary.postcode')}:{' '}
                                      </label>
                                      <label className="info">
                                        {' '}
                                        {Postcode}
                                      </label>
                                    </label>
                                    <label className="leftInfo">
                                      <label className="sub-info">
                                        {t('formulary.abn')}:{' '}
                                      </label>
                                      <label className="info"> {Abn}</label>
                                    </label>
                                  </div>
                                </div>
                              );
                            }}
                          />

                          <div className="icon-button-partner">
                            <Button.Group>
                              <Button
                                type="button"
                                labelPosition="left"
                                icon="search"
                                content={t('actions.search')}
                                className="search-button-contact"
                                onClick={() => handleSearchChange()}
                                loading={searchLoading}
                                disabled={searchLoading}
                              ></Button>
                            </Button.Group>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className="col inputs-right-align-flex">
                  {viewOnly ? (
                    <CustomInput
                      id="acn"
                      name="acn"
                      className="venue-inputs-acn-new"
                      placeholder={t('formulary.placeholder.enter_abn_acn')}
                      labelText={<div>{t('formulary.abn_acn')}</div>}
                      disabled={viewOnly}
                      requiredStar
                    />
                  ) : (
                    <CustomInput
                      id="acn"
                      className="venue-inputs-acn-new"
                      name="acn"
                      placeholder={t('formulary.placeholder.enter_abn_acn')}
                      labelText={<div>{t('formulary.abn_acn')}</div>}
                      defaultValue={selectedAbn}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          {isAnonymous && (
            <div className="contact-flex">
              <div className="col inputs-left-align-flex">
                <CustomInput
                  id="streetAddress"
                  name="streetAddress"
                  labelText={t('formulary.address_line_1')}
                  className={
                    isAnonymous ? 'partner-inputs-disabled' : 'venue-inputs-new'
                  }
                  disabled={viewOnly}
                />
              </div>
              <div className="col inputs-right-align-flex">
                <CustomInput
                  id="streetAddress2"
                  name="streetAddress2"
                  labelText={t('formulary.address_line_2')}
                  disabled={viewOnly}
                />
              </div>

              <div className="contact-flex">
                <div className="col inputs-left-align-flex">
                  <CustomInput
                    id="suburb"
                    name="suburb"
                    className={'venue-inputs-new'}
                    labelText={t('formulary.suburb')}
                    disabled={viewOnly}
                  />
                </div>
                <div className="col">
                  <CustomInput
                    id="state"
                    name="state"
                    className={'venue-inputs-new'}
                    labelText={t('formulary.state')}
                    disabled={viewOnly}
                  />
                </div>
                <div className="col inputs-right-align-flex">
                  <CustomInput
                    id="postCode"
                    name="postCode"
                    className={'venue-inputs-new'}
                    labelText={t('formulary.postcode')}
                    disabled={viewOnly}
                  />
                </div>
              </div>
            </div>
          )}
          {!isAnonymous && (isNew || selectedPartner.isAnonymous) && (
            <div className="email-verification">
              <PartnerEmailVerificationForm
                isUserConfirmed={isUserConfirmed}
                setFieldValue={() => setFieldValue('email', '')}
                onConfirmation={(val) => onConfirmation(val)}
                onVerification={(val) => onVerification(val)}
              />
            </div>
          )}

          {!isAnonymous &&
            !isNew &&
            selectedPartner.partnerUserId !== null &&
            !selectedPartner.isAnonymous && (
              <EmailResponseFormExistingUser data={selectedPartner} />
            )}

          {!isAnonymous &&
            !isNew &&
            selectedPartner.partnerUserId === null &&
            !selectedPartner.isAnonymous && (
              <EmailResponseFormGuestUser
                data={selectedPartner}
                setOrganisationName={(value) => setOrganisationName(value)}
                handleResult={handleResult}
                closeResults={closeResults}
                searchResults={searchResults}
                handleSearchChange={handleSearchChange}
                searchLoading={searchLoading}
                organisationName={organisationName}
                setFieldValue={setFieldValue}
                reportOpen={reportOpen}
              />
            )}

          {/* existing user */}
          {userEmailResponse.isExistingUser &&
            !isAnonymous &&
            userEmailResponse.isVerified &&
            userEmailResponse.isConfirmed && (
              <EmailResponseFormExistingUser
                data={userEmailResponse}
                projected={projected}
              />
            )}

          {/* new gest user */}
          {userEmailResponse.isVerified &&
            !userEmailResponse.isExistingUser && (
              <EmailResponseFormGuestUser
                data={userEmailResponse}
                setOrganisationName={(value) => setOrganisationName(value)}
                handleResult={handleResult}
                closeResults={closeResults}
                searchResults={searchResults}
                handleSearchChange={handleSearchChange}
                searchLoading={searchLoading}
                organisationName={organisationName}
                setFieldValue={setFieldValue}
                reportOpen={reportOpen}
              />
            )}

          {isFromActivity && (
            <div className="formik-custom-field act-inputs-new">
              <label className="contact-category-header">
                {t('organisation.contacts.partner_form.relationship')}
              </label>
              <div className="partner-relationship">
                <CustomRadioGroup
                  options={PARTNER_RELATIONSHIP_TRANSLATION(t)}
                  name="supportType"
                  type="radio"
                  getValue={(e) => handleSupportType(e)}
                  setDefaultValue={supportType}
                  disabled={!isNew && selectedPartner.isFromProgramLevel}
                  requiredStar
                />
              </div>
            </div>
          )}

          {/* TAK-2086: In-kind value — shown on the activity, not counted in
              its Financial Result */}
          {isFromActivity && supportType === 'IN_KIND' && (
            <div className="col inputs-left-align-flex">
              <CustomInput
                id="inKindValue"
                name="inKindValue"
                type="number"
                min="0"
                step="0.01"
                placeholder="0.00"
                labelText={t(
                  'organisation.contacts.partner_form.in_kind_value'
                )}
                className="venue-inputs-new"
                disabled={
                  viewOnly || (!isNew && selectedPartner.isFromProgramLevel)
                }
              />
            </div>
          )}

          {isFromActivity && (
            <div className="col inputs-left-align-flex">
              <div className="partner-description">
                <CustomTextArea
                  name="description"
                  id="description"
                  className="w-100 txt-partner-description"
                  placeholder={t('formulary.placeholder.enter_description')}
                  labelText={t('formulary.description')}
                  disabled={!isNew && selectedPartner.isFromProgramLevel}
                />
              </div>
            </div>
          )}
          {/* {isFromActivity && (
            <div className="col inputs-left-align-flex over-ride-message">
              <Message
                color="orange"
                icon="exclamation circle"
                content={
                  <>
                    <span>
                      Key activity information is reported to your partners in
                      accordance with{' '}
                    </span>
                    <span className="link-url">
                      <a
                        href="https://stage.whitebox.org.au/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Takso terms and conditions
                      </a>
                    </span>
                    <br /> <br />
                    {!isNew &&
                      !isEmpty(selectedPartner) &&
                      isExternalLinkedActivity(selectedPartner) && (
                        <span>
                          {props.activity?.currentActivity?.parentActivity
                            ?.reportYear
                            ? `Final Reporting Date : ${moment(
                                props.activity.currentActivity.parentActivity
                                  .reportYear
                              ).format('DD MMM YYYY')}`
                            : null}
                        </span>
                      )}
                  </>
                }
              />
            </div>
          )} */}

          {!isEmpty(userEmailResponse.error) && userEmailResponse.error}
          {!viewOnly ? (
            <div className="contact-modal-buttons">
              <Button
                disabled={isNew ? addPartnerLoading : updatePartnerLoading}
                loading={isNew ? addPartnerLoading : updatePartnerLoading}
                content={
                  isNew
                    ? t('specific_actions.add_partner')
                    : t('actions.save_changes')
                }
                size="small"
                type="submit"
                className="Primary-Button"
              />
            </div>
          ) : null}
        </Form>
      )}
    </Formik>
  );
};

export const PartnerCreate = (props) => {
  const { projectId, disabled } = props;
  const { t } = useTranslation();
  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  return (
    <div className="add-contact-container">
      <Modal
        trigger={
          <Button
            disabled={disabled}
            className={
              projectId ? 'customColor-wrapper-contact' : 'Primary-Button'
            }
          >
            <Icon name="plus" />
            {t('organisation.contacts.add_new_partner')}
          </Button>
        }
        size="small"
        open={modal}
        onOpen={toggle}
        closeIcon={
          <div className="new-activity-modal-close-icon" onClick={toggle}>
            &times;
          </div>
        }
      >
        <Modal.Header className="modal-header-font">
          {t('organisation.contacts.add_new_partner')}
        </Modal.Header>
        <Modal.Content>
          <PartnerForm setModal={setModal} isNew={true} {...props} />
        </Modal.Content>
      </Modal>
    </div>
  );
};

const EmailResponseFormExistingUser = ({ data = {} }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Grid>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="existing-user-partner">
            <div className="formik-custom-field act-inputs-new">
              <label>{t('formulary.first_name')}</label>
              <Input
                id="firstName"
                name="firstName"
                value={get(data, 'firstName', '')}
                placeholder={t('formulary.placeholder.enter_first_name')}
                disabled
              />
            </div>
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="existing-user-partner">
            <div className="formik-custom-field act-inputs-new">
              <label>{t('formulary.last_name')}</label>
              <Input
                id="secondName"
                name="secondName"
                value={get(data, 'secondName', '')}
                placeholder={t('formulary.placeholder.enter_last_name')}
                disabled
              />
            </div>
          </div>
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="existing-user-partner-middle">
            <div className="formik-custom-field act-inputs-new">
              <label>{t('formulary.email')}</label>
              <Input
                id="email"
                name="email"
                value={get(data, 'email', '')}
                placeholder={t('formulary.placeholder.enter_email')}
                disabled
              />
            </div>
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="existing-user-partner-middle">
            <div className="formik-custom-field act-inputs-new">
              <label>{t('formulary.phone')}</label>
              <Input
                id="phone"
                name="phone"
                placeholder={t('formulary.placeholder.enter_phone')}
                value={get(data, 'phone', '')}
                disabled
              />
            </div>
          </div>
        </Grid.Column>
      </Grid>

      <>
        <Grid>
          <Grid.Column mobile={16} tablet={8} computer={8}>
            <div className="existing-user-partner-middle">
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.business_org_name')}</label>
                <Input
                  id="entityName"
                  name="entityName"
                  placeholder={t(
                    'formulary.placeholder.enter_business_org_name'
                  )}
                  value={
                    data.userData
                      ? get(data, 'userData.organisation.name', null) != null
                        ? get(data, 'userData.organisation.name', '')
                        : get(data, 'userData.organisationName', '')
                      : data.organisationName
                  }
                  disabled
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={8} computer={8}>
            <div className="existing-user-partner-middle">
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.abn')}</label>
                <Input
                  id="abn"
                  name="abn"
                  placeholder={t('formulary.placeholder.enter_abn')}
                  value={
                    data.userData
                      ? get(data, 'userData.organisation.name', null) != null
                        ? get(data, 'userData.organisation.abn', '')
                        : get(data, 'userData.abn', '')
                      : data.acn
                  }
                  disabled
                />
              </div>
            </div>
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column mobile={16} tablet={8} computer={8}>
            <div className="existing-user-partner-middle">
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.address_line_1')}</label>
                <Input
                  id="streetAddress"
                  name="streetAddress"
                  placeholder={t('formulary.placeholder.enter_address_line_1')}
                  value={
                    data.userData
                      ? get(
                          data,
                          'userData.organisation.streetAddress',
                          null
                        ) != null
                        ? get(data, 'userData.organisation.streetAddress', '')
                        : get(data, 'userData.address1', '')
                      : data.streetAddress
                  }
                  disabled
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={8} computer={8}>
            <div className="existing-user-partner-middle">
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.address_line_2')}</label>
                <Input
                  id="streetAddress2"
                  name="streetAddress2"
                  placeholder={t('formulary.placeholder.enter_address_line_2')}
                  value={
                    data.userData
                      ? get(
                          data,
                          'userData.organisation.streetAddress2',
                          null
                        ) != null
                        ? get(data, 'userData.organisation.streetAddress2', '')
                        : get(data, 'userData.address2', '')
                      : data.streetAddress2
                  }
                  disabled
                />
              </div>
            </div>
          </Grid.Column>
        </Grid>

        <Grid>
          <Grid.Column mobile={16} tablet={6} computer={6}>
            <div className="existing-user-partner-middle">
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.suburb')}</label>
                <Input
                  id="suburb"
                  name="suburb"
                  placeholder={t('formulary.placeholder.enter_suburb')}
                  value={
                    data.userData
                      ? get(data, 'userData.organisation.citySuburb', null) !=
                        null
                        ? get(data, 'userData.organisation.citySuburb', '')
                        : get(data, 'userData.suburb', '')
                      : data.suburb
                  }
                  disabled
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={5} computer={5}>
            <div className="existing-user-partner-middle">
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.state')}</label>
                <Input
                  id="state"
                  name="state"
                  placeholder={t('formulary.placeholder.enter_state')}
                  value={
                    data.userData
                      ? get(
                          data,
                          'userData.organisation.orgState.name',
                          null
                        ) != null
                        ? get(data, 'userData.organisation.orgState.name', '')
                        : get(data, 'userData.state', '')
                      : data.state
                  }
                  disabled
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={5} computer={5}>
            <div className="existing-user-partner-middle">
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.postcode')}</label>
                <Input
                  id="postcode"
                  name="postcode"
                  placeholder={t('formulary.placeholder.enter_postcode')}
                  value={
                    data.userData
                      ? get(data, 'userData.organisation.postcode', null) !=
                        null
                        ? get(data, 'userData.organisation.postcode', '')
                        : get(data, 'userData.postcode', '')
                      : data.postCode
                  }
                  disabled
                />
              </div>
            </div>
          </Grid.Column>
        </Grid>
      </>
    </div>
  );
};

const EmailResponseFormGuestUser = ({
  data = {}, // FIXME: is this used ?
  setOrganisationName,
  organisationName,
  handleResult,
  searchResults,
  setFieldValue,
  reportOpen,
  closeResults,
  handleSearchChange,
  searchLoading,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <Grid>
        <Grid.Column
          className="partner-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <CustomInput
            id="firstName"
            name="firstName"
            placeholder={t('formulary.placeholder.enter_first_name')}
            labelText={t('formulary.first_name')}
            // disabled={disabled}
            requiredStar
          />
        </Grid.Column>
        <Grid.Column
          className="partner-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <CustomInput
            id="secondName"
            name="secondName"
            placeholder={t('formulary.placeholder.enter_last_name')}
            labelText={t('formulary.last_name')}
            // disabled={disabled}
            requiredStar
          />
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column
          className="partner-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <CustomInput
            id="email"
            name="email"
            // getValue={e => changeEmail(e)}
            placeholder={t('formulary.placeholder.enter_email')}
            labelText={t('formulary.email')}
            disabled={true}
            requiredStar
          />
        </Grid.Column>
        <Grid.Column
          className="partner-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <CustomInput
            id="phone"
            name="phone"
            placeholder={t('formulary.placeholder.enter_phone')}
            labelText={t('formulary.phone')}
            // disabled={disabled}
            requiredStar
          />
        </Grid.Column>
        <Grid.Column
          className="partner-activity-model-column"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <div className="guest-searchbar">
            <div className="formik-custom-field act-inputs-new ">
              <label>{t('formulary.business_org_name')}</label>

              <div className="search-fl">
                <Search
                  name="organisationName"
                  onResultSelect={(e, obj) =>
                    handleResult(e, obj, setFieldValue)
                  }
                  onSearchChange={(e, data) => {
                    setOrganisationName(data.value);
                  }}
                  open={reportOpen}
                  onBlur={closeResults}
                  icon="none"
                  results={searchResults}
                  className="contactSearch search-custom-height"
                  value={organisationName}
                  placeholder={t('actions.search')}
                  resultRenderer={({ Abn, Name, Postcode, State }) => {
                    return (
                      <div>
                        <label>
                          {Name.charAt(0).toUpperCase() + Name.slice(1)}
                        </label>
                        <div className="contact-search-result">
                          <label>
                            <label className="sub-info">
                              {t('formulary.state')}:{'  '}
                            </label>
                            <label className="info"> {State}</label>
                          </label>
                          <label className="leftInfo">
                            <label className="sub-info">
                              {t('formulary.postcode')}:{' '}
                            </label>
                            <label className="info"> {Postcode}</label>
                          </label>
                          <label className="leftInfo">
                            <label className="sub-info">
                              {t('formulary.abn')}:{' '}
                            </label>
                            <label className="info"> {Abn}</label>
                          </label>
                        </div>
                      </div>
                    );
                  }}
                />

                <div className="icon-button-partner">
                  <Button.Group>
                    <Button
                      type="button"
                      labelPosition="left"
                      icon="search"
                      content={t('actions.search')}
                      className="search-button-contact"
                      onClick={() => handleSearchChange()}
                      loading={searchLoading}
                      disabled={searchLoading}
                    ></Button>
                  </Button.Group>
                </div>
              </div>
            </div>
          </div>
        </Grid.Column>
        <Grid.Column
          className="partner-activity-model-column-pr"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <CustomInput
            id="acn"
            name="acn"
            className="venue-inputs-acn-new"
            placeholder={t('formulary.placeholder.enter_abn_acn')}
            labelText={t('formulary.abn_acn')}
            requiredStar
          />
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column
          className="partner-activity-model-column-pr"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <CustomInput
            id="streetAddress"
            name="streetAddress"
            placeholder={t('formulary.placeholder.enter_address_line_1')}
            labelText={t('formulary.address_line_1')}
            requiredStar
          />
        </Grid.Column>
        <Grid.Column
          className="partner-activity-model-column-pr"
          mobile={16}
          tablet={8}
          computer={8}
        >
          <CustomInput
            id="streetAddress2"
            name="streetAddress2"
            placeholder={t('formulary.placeholder.enter_address_line_2')}
            labelText={t('formulary.address_line_2')}
          />
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column
          className="partner-activity-model-column"
          mobile={16}
          tablet={6}
          computer={6}
        >
          <CustomInput
            id="suburb"
            name="suburb"
            placeholder={t('formulary.placeholder.enter_suburb')}
            labelText={t('formulary.suburb')}
            requiredStar
          />
        </Grid.Column>
        <Grid.Column
          className="partner-activity-model-column"
          mobile={16}
          tablet={5}
          computer={5}
        >
          <CustomInput
            id="state"
            name="state"
            placeholder={t('formulary.placeholder.enter_state')}
            labelText={t('formulary.state')}
            requiredStar
          />
        </Grid.Column>
        <Grid.Column
          className="partner-activity-model-column"
          mobile={16}
          tablet={5}
          computer={5}
        >
          <CustomInput
            id="postCode"
            name="postCode"
            placeholder={t('formulary.placeholder.enter_postcode')}
            labelText={t('formulary.postcode')}
            requiredStar
          />
        </Grid.Column>
      </Grid>
    </div>
  );
};

const PartnerActivityHistory = (props) => {
  const [modal, setModal] = useState(false);
  const { t } = useTranslation();

  const toggle = () => {
    setModal(!modal);
  };

  return (
    <div className="add-user">
      <Modal
        trigger={
          <label className="org-users-actions-warn">
            {t('organisation.contacts.view_history')}
          </label>
        }
        size="large"
        open={modal}
        onOpen={toggle}
        closeIcon={
          <div className="new-activity-modal-close-icon" onClick={toggle}>
            &times;
          </div>
        }
      >
        <Modal.Header className="modal-header-font">
          {t('common.activities')}
        </Modal.Header>
        <Modal.Content>
          {/* part1 */}
          <PartnerActivityViewHistory
            isNew={false}
            viewOnly={true}
            {...props}
          />
        </Modal.Content>
      </Modal>
    </div>
  );
};

const PartnerView = (props) => {
  const [modal, setModal] = useState(false);
  const { t } = useTranslation();

  const toggle = () => {
    setModal(!modal);
  };

  return (
    <div className="add-user">
      <Modal
        trigger={<label className="edit-org">{t('actions.view')}</label>}
        size="small"
        open={modal}
        onOpen={toggle}
        closeIcon={
          <div className="new-activity-modal-close-icon" onClick={toggle}>
            &times;
          </div>
        }
      >
        <Modal.Header className="modal-header-font">
          {t('common.activities')}
        </Modal.Header>
        <Modal.Content>
          <PartnerForm isNew={false} viewOnly={true} {...props} />
        </Modal.Content>
      </Modal>
    </div>
  );
};

export const PartnerUpdate = (props) => {
  const { t } = useTranslation();
  const { selectedPartner } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  return (
    <div className="add-user">
      <Modal
        trigger={
          <label className="edit-org">
            {isExternalLinkedActivity(selectedPartner)
              ? t('actions.view')
              : t('actions.edit')}
          </label>
        }
        onClick={(e) => stopPropagation(e)}
        onFocus={(e) => stopPropagation(e)}
        size="small"
        open={modal}
        onOpen={toggle}
        closeIcon={
          <div className="new-activity-modal-close-icon" onClick={toggle}>
            &times;
          </div>
        }
      >
        <Modal.Header className="modal-header-font">
          {t('actions.update_partner')}
          {!isEmpty(selectedPartner.name.trim()) && `- ${selectedPartner.name}`}
        </Modal.Header>
        <Modal.Content>
          <PartnerForm setModal={setModal} isNew={false} {...props} />
        </Modal.Content>
      </Modal>
    </div>
  );
};

export const PartnerCreateFromActivity = (props) => {
  const { projectId, disabled } = props;
  const { t } = useTranslation();

  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  return (
    <div className="add-user">
      <Modal
        size="small"
        open={modal}
        trigger={
          <Button
            disabled={disabled}
            className={
              projectId ? 'customColor-wrapper-contact' : 'customColor'
            }
          >
            <Icon name="plus" />
            {t('organisation.contacts.add_new_partner')}
          </Button>
        }
        onOpen={toggle}
        closeIcon={
          <div className="new-activity-modal-close-icon" onClick={toggle}>
            &times;
          </div>
        }
      >
        <Modal.Header className="modal-header-font">
          {t('organisation.contacts.add_new_partner')}
        </Modal.Header>
        <Modal.Content>
          <PartnerForm
            isFromActivity={true}
            setModal={setModal}
            isNew={true}
            {...props}
          />
        </Modal.Content>
      </Modal>
    </div>
  );
};

export const PartnerUpdateFromActivity = (props) => {
  const { selectedPartner, modal, setModal } = props;
  const { t } = useTranslation();

  return (
    <Modal
      size="small"
      open={modal}
      closeIcon={
        <div
          className="new-activity-modal-close-icon"
          onClick={() => setModal(false)}
        >
          &times;
        </div>
      }
    >
      <Modal.Header className="modal-header-font">
        {t('actions.update_partner')}
        {!isEmpty(selectedPartner) &&
          !isEmpty(selectedPartner.name.trim()) &&
          `- ${selectedPartner.name}`}
      </Modal.Header>
      <Modal.Content>
        <PartnerForm
          isFromActivity={true}
          isAssignExistingPartner={true}
          setModal={setModal}
          isNew={false}
          {...props}
        />
      </Modal.Content>
    </Modal>
  );
};

const PartnerDelete = (props) => {
  const { t } = useTranslation();
  const { selectedPartner } = props;
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  const deleteOrgPartnerHandler = () => {
    const { selectedPartner, resetPage } = props;
    dispatch(deleteOrgPartner(selectedPartner.id));
    if (resetPage) resetPage();
    toggle();
  };

  return (
    <div className="add-contact-container">
      <Modal
        open={modal}
        onOpen={() => toggle()}
        onClose={() => toggle()}
        onClick={(e) => stopPropagation(e)}
        onFocus={(e) => stopPropagation(e)}
        size="small"
        trigger={
          <div className="partner-model-style">
            <label className="edit-org">
              <div className="partners-remove-view">{t('actions.remove')}</div>
            </label>
          </div>
        }
      >
        <Modal.Header className="modal-header-font">
          {t('organisation.contacts.delete_partner_with_name', {
            name: selectedPartner.name,
          })}
        </Modal.Header>
        <Modal.Content>
          <p>{t('organisation.contacts.confirm_delete_partner')}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => toggle()} className="modal-cancel">
            {t('actions.no')}
          </Button>
          <Button
            onClick={() => deleteOrgPartnerHandler()}
            positive
            className="modal-proceed"
            content={t('actions.yes')}
          />
        </Modal.Actions>
      </Modal>
    </div>
  );
};

//partnerview activity history

const PartnerActivityViewHistory = (props) => {
  const { t, i18n } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();

  const organisation = useSelector((state) => state.organization);

  const { partnerActHistory = [], loading = false } = organisation;

  useEffect(() => {
    dispatch(getOrgPartnersHistory(props.selectedPartner.id, currentPage));
  }, []);

  const activityColumns = () => {
    return [
      {
        width: 5,
        title: (
          <div className="sort-icon">
            <div className="lib-header">{t('common.activity_name')}</div>
          </div>
        ),
        render: (data) => {
          return (
            <div className="activity-name">
              <div
                className={`circle circle-bottom activity-${getActivityStatus(
                  data.statusId
                )}`}
              />
              <label>
                <Link
                  to={`/activities/${data.id}`}
                  className="enter-activity-link"
                >
                  {data.name ? data.name : ''}
                </Link>
              </label>
            </div>
          );
        },
      },
      {
        width: 2,
        title: t('common.type'),
        render: (data) => {
          const actType = getActivityType(data);
          return actType.type;
        },
      },
      {
        width: 2,
        title: t('common.owner'),
        render: (data) => {
          return data.owner && data.owner.firstName
            ? data.owner.firstName
            : '-';
        },
      },
      {
        width: 2,
        title: (
          <div className="sort-icon">
            <div>{t('common.date_created')}</div>
          </div>
        ),
        render: (data) => {
          return new Intl.DateTimeFormat(i18n.language, {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          }).format(new Date(data.createdDateTime));
        },
      },
      {
        width: 2,
        title: (
          <div className="sort-icon">
            <div>{t('common.last_updated')}</div>
          </div>
        ),
        render: (data) => {
          return new Intl.DateTimeFormat(i18n.language, {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          }).format(new Date(data.lastEditedDateTime));
        },
      },
      {
        width: 3,
        title: '',
        render: (data) => {
          return (
            <div className="activity-actions-inside">
              <Link to={`/activities/${data.id}`}>
                <label className="activity-actions-enter-activity">
                  {t('actions.enter_activity')}
                </label>
              </Link>
            </div>
          );
        },
      },
    ];
  };

  const pageChange = (page) => {
    const { auth } = props;
    setCurrentPage(page);
    if (!isEmpty(auth.user) && auth.user.organisation) {
      dispatch(getOrgPartnersHistory(props.selectedPartner.id, currentPage));
    }
  };

  return (
    <Segment className="content-segment org-users" loading={loading}>
      <Grid>
        <Grid.Row className="add-contact-org-row">
          <Grid.Column
            mobile={16}
            tablet={16}
            computer={16}
            textAlign="right"
          ></Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {partnerActHistory.docs && partnerActHistory.docs.length > 0 ? (
            <Grid.Column className="org-table-container-">
              <CustomTable
                header
                columns={activityColumns()}
                height={true}
                data={partnerActHistory.docs}
                customClass="org-users-table"
                pagination
                handlePaginationChange={(page) => pageChange(page)}
                page={currentPage}
                noOfPages={partnerActHistory.pages}
                keyExtractor={(item, index) => item.id}
              />
            </Grid.Column>
          ) : (
            <EmptyContainer
              msg={t('organisation.contacts.no_activities_for_partner')}
            />
          )}
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

const OrganizationPartners = (props) => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);

  const dispatch = useDispatch();

  const organisation = useSelector((state) => state.organization);
  const { orgPartners = [], loading = false } = organisation;

  useEffect(() => {
    dispatch(getOrgPartners(currentPage));
  }, []);

  const resetPage = () => {
    setCurrentPage(1);
  };

  const columns = () => {
    return [
      {
        title: (
          <div className="partner-name">
            <div className="sort-icon">
              <div className="lib-header-partner"> {t('common.name')}</div>
            </div>
          </div>
        ),
        render: (data) => {
          const fullName = data && data.name && `${data.name}`;
          return (
            <div>
              <div className="current-member-text pl-3 pt-3">
                {data ? data.organisationName && data.organisationName : null}
              </div>
              <div className="current-member-text pl-3 text-muted">
                {/* Check weather this user from takso or not */}
                {data && data.partnerUserId ? (
                  <span>
                    <img className="plus-icon" alt="plus" src={syslogo} />
                  </span>
                ) : null}
                {data && fullName !== undefined ? fullName && fullName : ''}
              </div>
            </div>
          );
        },
      },
      {
        title: t('formulary.email'),
        render: (data) => {
          return (
            <label className="org-users-text-partner">
              {data.email || '-'}
            </label>
          );
        },
      },
      {
        title: t('formulary.phone'),
        render: (data) => {
          return (
            <label className="org-users-text-partner">
              {data.phone || '-'}
            </label>
          );
        },
      },
      {
        title: '',
        render: (data) => {
          return (
            <div className="org-users-text-partner-view-history">
              <PartnerActivityHistory selectedPartner={data} {...props} />
            </div>
          );
        },
      },
      {
        width: 1,
        title: (
          <div className="user-act-heading-container">
            <strong></strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className="org-users-text-partner">
              <div className="owned">
                <Dropdown
                  icon="ellipsis vertical"
                  direction="left"
                  inline
                  selectOnBlur={false}
                >
                  {/* View-user eith the taskso tag */}
                  <Dropdown.Menu>
                    {data && data.partnerUserId ? (
                      <Dropdown.Item
                        text={t('actions.view')}
                        className="dropdown-customItem"
                      >
                        <PartnerView selectedPartner={data} {...props} />
                      </Dropdown.Item>
                    ) : null}

                    {/* Edit-user without 'takso' tag */}

                    {!(data && data.partnerUserId) ? (
                      <Dropdown.Item
                        text={t('actions.edit')}
                        className="dropdown-customItem"
                      >
                        <PartnerUpdate
                          selectedPartner={data}
                          resetPage={resetPage}
                          {...props}
                        />
                      </Dropdown.Item>
                    ) : null}
                    {!(data && !isEmpty(data.projectPartner)) ? (
                      <Dropdown.Item
                        text={t('actions.remove')}
                        className="dropdown-customItem"
                      >
                        <PartnerDelete
                          selectedPartner={data}
                          resetPage={resetPage}
                          {...props}
                        />
                      </Dropdown.Item>
                    ) : null}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          );
        },
      },
    ];
  };

  const pageChange = (page) => {
    const { auth } = props;

    setCurrentPage(page);
    if (!isEmpty(auth.user) && auth.user.organisation) {
      dispatch(getOrgPartners(page));
    }
  };

  return (
    <Segment className="content-segment org-users" loading={loading}>
      <Grid>
        <Grid.Row className="add-contact-org-row">
          <Grid.Column mobile={16} tablet={16} computer={16} textAlign="right">
            <PartnerCreate {...props} resetPage={() => this.resetPage()} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {orgPartners.docs && orgPartners.docs.length > 0 ? (
            <Grid.Column className="org-table-container">
              <CustomTable
                header
                columns={columns()}
                height={true}
                data={orgPartners.docs}
                customClass="org-users-table"
                pagination
                handlePaginationChange={(page) => pageChange(page)}
                page={currentPage}
                noOfPages={orgPartners.pages}
                keyExtractor={(item, index) => item.id}
              />
            </Grid.Column>
          ) : (
            // TODO: check if good, initially no_activities_for_partner
            <EmptyContainer msg={t('organisation.contacts.no_partners')} />
          )}
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default OrganizationPartners;
